import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormLabel from "@mui/material/FormLabel"
import MatRadio from "@mui/material/Radio"
import RadioGroup, {
  RadioGroupProps as MatRadioGroupProps,
} from "@mui/material/RadioGroup"

import React, { ChangeEvent, FC } from "react"

import { create } from "src/helpers/bem"
import { TranslationMessages } from "src/translations"

import styles from "./Radio.module.scss"

const bem = create(styles, "Radio")

export type RadioOption = {
  key: string | number
  value: string
  disabled?: boolean
}

export type RadioProps = MatRadioGroupProps & {
  required?: boolean
  disabled?: boolean
  label?: string
  isValid?: boolean
  errorText?: string
  messages?: TranslationMessages
  helperText?: string
  items?: RadioOption[]
  onValidate?: (error?: string) => void
}

export const Radio: FC<RadioProps> = ({
  value = "",
  label,
  required,
  disabled,
  items,
  name,
  messages,
  classes,
  isValid,
  errorText,
  helperText,
  onChange,
  onValidate,
  ...props
}) => {
  const validate = (value: string) => {
    if (!onValidate) {
      return null
    }
    if (required && !value) {
      return onValidate(
        messages?.components?.common?.fields?.required ??
          "This field is required!",
      )
    }

    return onValidate(undefined)
  }

  const handleValidation = (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    const value = e?.target?.value
    validate(value)
  }

  return (
    <FormControl
      className={bem(
        undefined,
        isValid !== undefined && !isValid ? "invalid" : undefined,
      )}
    >
      {label && (
        <FormLabel id={`${name}-label`} required={required}>
          {label}
        </FormLabel>
      )}
      <RadioGroup
        {...props}
        aria-labelledby={`${name}-label`}
        name={name}
        value={value}
        onChange={
          onChange &&
          ((e, value) => {
            handleValidation?.(e)
            onChange(e, value)
          })
        }
      >
        {items?.map((item) => (
          <FormControlLabel
            key={item.key}
            control={<MatRadio />}
            disabled={disabled ?? item.disabled ?? false}
            label={item.value}
            value={item.key}
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}
